import { atom } from 'jotai';

// An atom for the unique requirement submission
export const uniqueRequirementAtom = atom(true);

// An atom to set that the user is on the requirements page
export const isRequirementsPageAtom = atom(false);
